import React from 'react';
import PropTypes from 'prop-types';
import TransactionService from "../TransactionService";
import Box from "../../component/Box/Box";
import {FormGroup, Table} from "react-bootstrap";
import Notify from "../../services/Notify";
import FormButtons from "../../component/Form/FormButtons";
import Loading from "../../component/Loading/Loading";
import MovementOrderSelector from "../../movementOrder/component/MovementOrderSelector";

class TransactionPendingForm extends React.Component {

  service = new TransactionService();
  refs = {};

  constructor(props) {
    super(props);
    this.state = {entity: {}};
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    const state = this.state;
    state.loading = true;
    this.setState(state);
    this.service.findById(id).then(
        data => this.setState(
            {
              loading: false,
              entity: data
            }),
        error => {
          const state = {loading: false};
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
    )
  }

  submitForm(e) {
    e.preventDefault();
    const {match} = this.props;
    const id = match.params.id;
    const entity = {
      id: this.movementOrderId
    };
    this.setState({loading: true, message: 'Salvando...'});
    this.service.assocMovementOrder(id, entity).then(
        (data) => {
          Notify.success('Transação criada, ela sera processada em breve');
          this.props.history.push('/transactions/' + data.id);
        },
        (error) => {
          Notify.error('Falha ao criar transação:', error);
          this.setState({loading: false, entity, message: null});
        });
  }

  items(items = []) {
    return (<Table>
      <thead>
      <tr>
        <th>Referencia</th>
        <th>Nome</th>
      </tr>
      </thead>

      <tbody>
      {items.map(({productType}) => (
          <tr key={productType.reference}>
            <td>{productType.reference}</td>
            <td>{productType.friendlyName}</td>
          </tr>
      ))}
      </tbody>
    </Table>);
  }

  render() {
    const {loading, entity, message, movementOrder = {}} = this.state;
    console.log(movementOrder);

    if (loading) {
      return <Loading message={message}/>
    }

    return (<div>

          <form onSubmit={(e) => this.submitForm(e)}>

            <Box info>
              <MovementOrderSelector onChange={(value) => {
                this.setState({movementOrder: value});
              }} setValue={movementOrder => this.movementOrderId = movementOrder}/>

              <FormGroup style={{padding: 15}}>
                {this.items(movementOrder.products)}
              </FormGroup>

            </Box>


            <Box info title="Items da transação">
              {/*{entity.transactionItems ? <TransactionItemList history={this.props.history} items={entity.transactionItems}/> : ''}*/}
            </Box>

            <FormButtons history={this.props.history}/>

          </form>


        </div>
    );
  }
}

TransactionPendingForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default TransactionPendingForm;



// WEBPACK FOOTER //
// ./src/transaction/component/TransactionPendingForm.js